export enum supportedLanguages {
    pt = "pt",
    es = "es",
  }
  
  export enum availableFeatures {
    assinaturaDeDesign = "assinaturaDeDesign",
    coluna = "coluna",
    retrovisor = "retrovisor",
    soleira = "soleira",
    biTone = "biTone",
    tetoSolar = "tetoSolar",
    farolGrade = "farolGrade",
    lanternaTraseira = "lanternaTraseira",
    rodas = "rodas",
    telas = "telas",
    somBose = "somBose",
    cambio = "cambio",
  }
  
  export interface IFeature {
    title: string;
    subtitle: string;
    description: string;
  }
  
  export interface ICopy {
    loadingScreen: {
      disclaimer: string;
      cta: string;
    };
    landingScreen: {
      title: string;
      titleMobile: string;
      subtitle: string;
      cta: string;
      ctaMobile: string;
      disclaimer: string;
    };
    homeScreen: {
      title: string;
      subtitle: string;
      learnMoreCta: string;
      learnMoreCtaURL: string;
      interiorCta: string;
      exteriorCta: string;
      eventCtaPre: string;
      eventCtaPreURL: string;
      eventCtaLive: string;
      eventCtaPos: string;
      promotionalCta: string;
      joystickCta: string;
    };
    event: {
      title: string;
      subtitle: {
        left: string;
        right: string;
      };
      date: string;
      label: string;
      time: {
        days: string;
        hours: string;
        minutes: string;
        seconds: string;
      };
      location: string;
      cta: string;
      eventDay: string;
    },
    preSale: {
      title: string;
      subtitle: {
        left: string;
        right: string;
      };
      date: string;
      label: string;
      time: {
        days: string;
        hours: string;
        minutes: string;
        seconds: string;
      };
      location: string;
      cta: string;
      eventDay: string;
    },
    gallery: {
      title: string;
      subtitle: string;
    },
    features: {
      [availableFeatures.somBose]: IFeature;
      [availableFeatures.assinaturaDeDesign]: IFeature;
      [availableFeatures.soleira]: IFeature;
      [availableFeatures.cambio]: IFeature;
      [availableFeatures.coluna]: IFeature;
      [availableFeatures.retrovisor]: IFeature;
      [availableFeatures.farolGrade]: IFeature;
      [availableFeatures.lanternaTraseira]: IFeature;
      [availableFeatures.tetoSolar]: IFeature;
      [availableFeatures.telas]: IFeature;
      [availableFeatures.biTone]: IFeature;
      [availableFeatures.rodas]: IFeature;
    }
  }